export default "__VITE_ASSET__DqaRfaIB__"